import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { TemplateSummary } from '../campaign-model/campaign-model';
import { CampaignService } from '../campaign-service/campaign-service';

/**
 * Manage Template — the list of saved email templates, and the way in to "Create Template".
 * Reached from the Campaign → Create Template side nav item; laid out to match Manage Campaign.
 *
 * ⚠️ No template-list endpoint exists in `environment.apis` yet, so the table starts empty. See the
 * TODO in `fetchTemplates()`.
 */
@Component({
  selector: 'app-manage-template',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIcon,
    MatTableModule,
    PiasLayoutComponent
  ],
  templateUrl: './manage-template.component.html',
  styleUrl: './manage-template.component.scss'
})
export class ManageTemplateComponent implements OnInit {

  private router = inject(Router);
  private campaignService = inject(CampaignService);

  protected displayedColumns: string[] = ['name', 'channel', 'startDate', 'endDate', 'status', 'actions'];
  protected dataSource = new MatTableDataSource<TemplateSummary>([]);

  ngOnInit(): void {
    this.fetchTemplates();
  }

  protected onView(template: TemplateSummary): void {
    this.router.navigate(['/campaign/create-template'], {
      queryParams: { id: template.id, mode: 'view' }
    });
  }

  protected onEdit(template: TemplateSummary): void {
    this.router.navigate(['/campaign/create-template'], {
      queryParams: { id: template.id, mode: 'edit' }
    });
  }

  // private fetchTemplates(): void {
  //   // TODO(backend): no template-list endpoint exists in `environment.apis` yet. Once it does, add
  //   // `listTemplates()` to CampaignService following the axios + manual-Authorization pattern used
  //   // by `listcampaign()`, and assign the result (newest first) to `this.dataSource.data` here.

  //   this.dataSource.data = [];
  // }
  private async fetchTemplates(): Promise<void> {
    const templates = await this.campaignService
      .listTemplates()
      .catch((error) => {
        console.error('Failed to load templates:', error);
        return [];
      });

    // "newest first" per the TODO — sort by id descending (higher id = created later).
    // ⚠️ Confirm against the real backend response once the endpoint is live; switch
    // to a createdAt/timestamp field instead if the backend provides one.
    this.dataSource.data = [...templates].sort((a, b) => b.id - a.id);
  }

  protected newTemplate(): void {
    this.router.navigate(['/campaign/create-template']);
  }

  //  // Status is derived from the dates: end date -> inactive, only start date -> active, none -> draft.
  // protected getStatus(element: TemplateSummary): string {
  //   if (element.endDate || element.startDate) {
  //     return 'inactive';
  //   }
  //   if (element.startDate) {
  //     return 'active';
  //   }
  //   return 'draft';
  // }

}
